import React, { useEffect, useMemo, useState } from "react";
import Api from "../../utils/Api";
import "../../../css/LookerReportPage.css";
import { useFeatureFlagStore } from "../../storez/FeatureFlagStore";
import PageTitle from "../title/PageTitle";

export default function LookerPageWrapper(props) {
  const [allow, setAllow] = useState(false);
  const [embedUrl, setEmbedUrl] = useState("");

  useEffect(() => {
    useFeatureFlagStore
      .getState()
      .getOrFetch()
      .then((flags) => {
        // TODO: Use `requireFeatureFlags` check in `AppRoot.js` instead for better UX!
        setAllow(!!flags[props.route.featureFlag]);
      });
  });

  useEffect(() => {
    Api.get(
      props.route.apiEndpoint,
      function (result) {
        setEmbedUrl(result);
      },
      function (result) {
        console.log("Unable to generate Looker Embed URL: " + result);
        setEmbedUrl("");
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const title = useMemo(() => {
    switch (props.route.path) {
      default:
      case "/reports/advanced":
        return "Advanced Search";
      case "/reports/wellbeing":
        return "Student Wellbeing";
      case "/reports/behaviour":
        return "Student Behaviour";
      case "/reports/activity":
        return "Student Activity";
      case "/reports/distracted":
        return "Digital Distraction Report";
      case "/reports/compliance":
        return "Activity & Compliance Report";
    }
  }, [props.route.path]);

  if (!allow) return <div />;

  return (
    <>
      <PageTitle title={title} />
      <iframe width="100%" height="100%" src={embedUrl} className="LookerACS" title="Looker Dashboard"></iframe>
    </>
  );
}
